import {
  StepChangeDirection,
  ThreeStepsDetails,
  FileListData,
} from '@typings/ResidentTypes';

import { DateObjectType, SubmitStatus } from '@typings/common';
// eslint-disable-next-line import/no-cycle
import {
  ShowSuccessNotificationType,
  SuccessNotiPositionEnum,
} from '../commons';

export const stepTwofieldMappings = {
  careStatus: 'Current care status',
  furtherCareStatus: 'Further Information',
  roomNumberOrName: 'Enter room number or name:',
  advanceCarePlan:
    'Is there a previously created Advance Care Plan available for the resident?',
  acpDocuments: 'ACP Documents',
  acpFurtherInformation:
    'Further information and details about previously created Advance Care Plans',
  planUpdatedDate: 'The Date this plan was last updated',
  advanceDecision:
    'Has an Advance Decision to Refuse Treatment been completed?',
  cprDnacpr: 'Has a CPR / DNACPR form been completed?',
  acmp: 'Has a Medical Anticipatory Clinical Management Plan (ACMP) been completed?',
  residentFurtherInformation:
    'If the resident has any specific, non-medicalised requirements please enter them below',
  healthAndWelfareLPAStatus: 'Lasting power of attorney for health and welfare',
  lpaLocation: 'The location of the LPA information',
  lpaDeputies: 'The names of any appointed people or deputies',
  lpaFullName: 'LPA contact full name',
  lpaEmail: 'LPA contact email',
  lpaPhoneNumber: 'LPA contact phone number',
  lpaRelationship: 'LPA contact relationship',
  uploadedLpaFileList:
    'Upload a copy of the Lasting Power of Attorney for health and welfare',
};

export interface StepTwoProps {
  role: string;
  slug: string | undefined;
  userId: string;
  threeStepsData: ThreeStepsDetails;
  isFormChanged: boolean;
  residentFullName: string;
  setIsFormChanged: (isFormChanged: boolean) => void;
  changeStep: (status: StepChangeDirection) => void;
  onSubmitThreeStepsData: (
    submitValues: ThreeStepsDetails,
    postion: SuccessNotiPositionEnum
  ) => void;
  handleGetResidentDetails: () => Promise<void>;
  callApiStatus: SubmitStatus;
  showSuccessNotification: ShowSuccessNotificationType;
  setShowSuccessNotification: React.Dispatch<
    React.SetStateAction<ShowSuccessNotificationType>
  >;
}

export interface AdvanceDecisonType {
  status: string;
  updatedDate: DateObjectType;
  location: string;
}
export interface CprDecisionType {
  status: string;
  snomedCode: string | null;
  details: string;
  location: string;
  cprDocuments: FileListData[];
}

export interface AcmpType {
  status: string;
  updatedDate: DateObjectType;
  location: string;
}

export const successMessage = {
  title: 'Your progress has been saved',
  content: 'Please continue below',
};
